/**
 * MLS boards sold on a CRM deal ("credits") are spent at the payment step of
 * the normal Purchase MLS order. One order draws from a single deal
 * subscription, so it can cover at most `per_order` boards; the rest are paid
 * through Zoho checkout as usual. The backend decides the real split; this
 * only previews it.
 */
export function dealCreditCover(offer, boardCount) {
  const credits = offer?.deal_credits || {}
  const remaining = Math.max(0, Number(credits.remaining) || 0)
  const perOrder = Math.max(0, Number(credits.per_order) || 0)
  const count = Math.max(0, Number(boardCount) || 0)
  const covered = Math.min(count, perOrder)
  return {
    remaining,
    covered,
    charged: count - covered,
    remainingAfter: Math.max(0, remaining - covered),
    fullyCovered: count > 0 && covered === count,
  }
}

export function boardsLabel(count) {
  return `${count} board${count === 1 ? "" : "s"}`
}

/** "1 MLS board credit remaining → 0" */
export function creditsRemainingLabel({ remaining, remainingAfter }) {
  return `${remaining} MLS board credit${
    remaining === 1 ? "" : "s"
  } remaining → ${remainingAfter}`
}
